import { GET_PROVIDERS, GET_PROVIDERS_ERROR, GET_PROVIDERS_SUCCESS } from './ProvidersSection.actions'

const providersSectionState = {
  categories: [],
  csv: [],
  csvTableTender: [],
  data: [],
  error: null,
  loading: false
}

/**
 * The providers section's reducer.
 */
const providersSectionReducer = (state = providersSectionState, { payload, type }) => {
  switch (type) {
    case GET_PROVIDERS: {
      return { ...state, loading: true }
    }
    case GET_PROVIDERS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PROVIDERS_SUCCESS: {
      return {
        ...state,
        categories: payload.categories,
        csv: payload.csv,
        csvTableTender: payload.csvTableTender,
        data: payload.data,
        loading: false
      }
    }
    default: {
      return state
    }
  }
}

export default providersSectionReducer
